// Because of JS import hoisting, we need this init code to be here,
// so that following imports in application.js have access to `bootstrap`

import Rails from '@rails/ujs';
window.Rails = Rails
